export default (file:File): string => file.name.split(".").pop();
